import 'bulma';
import 'animate.css';
import VueWaves from 'vue-waves-button';
import 'vue-waves-button/waves.css';
import VueTouchRipple from 'vue-touch-ripple'
import 'vue-touch-ripple/dist/vue-touch-ripple.css'
import 'nprogress/nprogress.css';
import NProgress from 'nprogress';
import infiniteScroll from 'vue-infinite-scroll'
import VueMatchHeights from 'vue-match-heights';
import Meta from 'vue-meta'
import { firestorePlugin } from 'vuefire'


import Header from './componests/Header.vue';
import Stripes from './componests/Stripes.vue';
import MainImage from './componests/MainImage.vue';
import Block from './componests/Block.vue';
import AboutMe from './componests/AboutMe.vue';
import SideImage from './componests/SideImage.vue';
import Footer from './componests/Footer.vue';
import Menu from './componests/Menu.vue';
import BlogPost from './componests/BlogPost.vue';
import BlogContainer from './componests/BlogContainer.vue';
import Social from './componests/Social.vue';
import Modal from './componests/Modal.vue';
import Comment from './componests/Comment.vue';

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
// import './firebase';

Vue.component('cham-header', Header);
Vue.component('cham-stripes', Stripes);
Vue.component('cham-main-image', MainImage);
Vue.component('cham-block', Block);
Vue.component('cham-about-me', AboutMe);
Vue.component('cham-side-image', SideImage);
Vue.component('cham-footer', Footer);
Vue.component('cham-menu', Menu);
Vue.component('cham-blog-post', BlogPost);
Vue.component('cham-blog-container', BlogContainer);
Vue.component('cham-socail', Social);
Vue.component('cham-modal', Modal);
Vue.component('cham-comment', Comment);

Vue.config.productionTip = false

Vue.use(VueWaves);
Vue.use(VueTouchRipple);
Vue.use(infiniteScroll);
Vue.use(VueMatchHeights);
Vue.use(Meta);
Vue.use(firestorePlugin)

Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  NProgress.set(0.9)
  next()
})
router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/main.js